import { render } from "./ResponsibleMining.vue?vue&type=template&id=52b3f2f2"
import script from "./ResponsibleMining.vue?vue&type=script&lang=js"
export * from "./ResponsibleMining.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__